export interface IPromotionStp {
  serial: number;
  description: string;
  criteriaData: string; // for json data
  startDate: Date;
  lastExecuteDate: Date;
  templateId: number;
  hasFrequency: boolean;
  // scheduling poup
  freqFlag: number;
  freqType: number;
  freqQty: number;
  periodType: number;
  periodQty: number;
  quantity: number;
  days: number;
  expireDate: Date;
  startDayNo: number;

  periodDescAr: string;
  periodDescEn: string;
}

export interface IPromotionCriteria {
  // numbers
  ageFrom: number;
  ageTo: number;

  // multi selects
  gender: string;
  country: string;
  governate: string;
  city: string;
  level2ServiceCode: string;
  speciality: string;
  chronic: string;
  diagnois: string;

  // dates
  birthDateFrom: Date;
  birthDateTo: Date;
  visitDateFrom: Date;
  visitDateTo: Date;
  lastVisitDateFrom: Date;
  lastVisitDateTo: Date;
  serviceDateFrom: Date;
  serviceDateTo: Date;
}

export interface IPromotionLists {
  gender: IPromoListItem[];
  country: IPromoListItem[];
  governate: IPromoListItem[];
  city: IPromoListItem[];
  level2ServiceCode: IPromoListItem[];
  speciality: IPromoListItem[];
  chronic: IPromoListItem[];
  diagnois: IPromoListItem[];
}

export interface IPromotionsMsgLog {
  serial?: number;
  promotionCode?: number;
  patCode?: number;
  message?: string;
  sentDate?: Date;
  sender?: number;
  msgPrice?: number;
  rowsCount?: number;
  mobile?: number;
  callDataSerial?: number
  messageType?: number;
  regPatMedicalStepsSerial?: number;
  clinicReservationSerial?: number;
  markPatExpectedServiceSerial?: number;
}


export interface IPromotionMsgLogParms extends IPromotionsMsgLog {
  fromDate?: Date;
  toDate?: Date;
  offset?: number;
  pageSize?: number;
  fastSearchData?: string;
  ngbFromDate?: any;
  ngbToDate?: any;
  patCode?: number;
  messageType?: number
}



export interface IPromoListItem {
  code: number;
  nameAr: string;
  nameEn: string;
}

export interface MsgTemplate {
  moduleId: number
  fieldName: string
}

export interface IServiceProviderSetting {
  code: number;
  providerName?: string;
  contractBy?: number;
  smsProviderId?: number;
  active: boolean;
  username?: string;
  password?: string;
  token?: string;
  senderName?: string;

}
export interface SmsSendSetting extends IPromotionsMsgLog {
  serial?: number
  smsTrigger?: number
  notifcationPortalSettingSerial?: number
  sendFlag?: number

  doctorName?: string;
  shortDoctorName?: string;
  deviceName?: string;
  patientName?: string;
  clinicName?: string;
  patientArrangement?: string;
  patientWaiting?: string;
  reservationDateMsg?: string;
}

